import { useEffect, useRef } from "react";

interface RFLottieProps {
  options: {
    loop: boolean;
    autoplay: boolean;
    animationData: any;
  };
  height: number;
  width: number;
  style?: React.CSSProperties | undefined;
}

export default function RFLottie({
  options,
  height,
  width,
  style,
}: RFLottieProps) {
  const lottieRef = useRef<HTMLDivElement>(null);
  const animationRef = useRef<{ destroy: () => void } | null>(null);

  useEffect(() => {
    let cancelled = false;
    import("lottie-web").then((lottie) => {
      if (cancelled || !lottieRef.current) return;
      animationRef.current?.destroy();
      animationRef.current = lottie.default.loadAnimation({
        ...options,
        container: lottieRef.current as HTMLDivElement,
        renderer: "svg",
      });
    });
    return () => {
      cancelled = true;
      animationRef.current?.destroy();
      animationRef.current = null;
    };
  }, []);

  return (
    <div
      ref={lottieRef}
      style={{
        ...style,
        height: height,
        width: width,
        margin: "0 auto",
        overflow: "hidden",
      }}
    ></div>
  );
}
